/**

 * @作者 王

 * @创建于 2021/5/13 19:51

 */
if (window.__POWERED_BY_QIANKUN__) {
    __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
}
